'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var errCode = require('err-code');

var _require = require('uint8arrays/concat'),
    uint8arraysConcat = _require.concat;

var _require2 = require('uint8arrays/from-string'),
    uint8arraysFromString = _require2.fromString; // @ts-ignore libp2p-crypto does not support types


var cryptoKeys = require('libp2p-crypto/src/keys');

var PeerId = require('peer-id');

var varint = require('varint');

var _require3 = require('uint8arrays/equals'),
    uint8arraysEquals = _require3.equals;

var _require4 = require('../../errors'),
    codes = _require4.codes;

var _require5 = require('./envelope'),
    Protobuf = _require5.Envelope;
/**
 * @typedef {import('libp2p-interfaces/src/record/types').Record} Record
 */


var Envelope = /*#__PURE__*/function () {
  /**
   * The Envelope is responsible for keeping an arbitrary signed record
   * by a libp2p peer.
   *
   * @class
   * @param {object} params
   * @param {PeerId} params.peerId
   * @param {Uint8Array} params.payloadType
   * @param {Uint8Array} params.payload - marshaled record
   * @param {Uint8Array} params.signature - signature of the domain string :: type hint :: payload.
   */
  function Envelope(_ref) {
    var peerId = _ref.peerId,
        payloadType = _ref.payloadType,
        payload = _ref.payload,
        signature = _ref.signature;

    _classCallCheck(this, Envelope);

    this.peerId = peerId;
    this.payloadType = payloadType;
    this.payload = payload;
    this.signature = signature; // Cache

    this._marshal = undefined;
  }
  /**
   * Marshal the envelope content.
   *
   * @returns {Uint8Array}
   */


  _createClass(Envelope, [{
    key: "marshal",
    value: function marshal() {
      if (this._marshal) {
        return this._marshal;
      }

      var publicKey = cryptoKeys.marshalPublicKey(this.peerId.pubKey);
      this._marshal = Protobuf.encode({
        publicKey: publicKey,
        payloadType: this.payloadType,
        payload: this.payload,
        signature: this.signature
      }).finish();
      return this._marshal;
    }
    /**
     * Verifies if the other Envelope is identical to this one.
     *
     * @param {Envelope} other
     * @returns {boolean}
     */

  }, {
    key: "equals",
    value: function equals(other) {
      return uint8arraysEquals(this.peerId.pubKey.bytes, other.peerId.pubKey.bytes) && uint8arraysEquals(this.payloadType, other.payloadType) && uint8arraysEquals(this.payload, other.payload) && uint8arraysEquals(this.signature, other.signature);
    }
    /**
     * Validate envelope data signature for the given domain.
     *
     * @param {string} domain
     * @returns {Promise<boolean>}
     */

  }, {
    key: "validate",
    value: function validate(domain) {
      var signData = formatSignaturePayload(domain, this.payloadType, this.payload);
      return this.peerId.pubKey.verify(signData, this.signature);
    }
  }]);

  return Envelope;
}();
/**
 * Helper function that prepares a Uint8Array to sign or verify a signature.
 *
 * @param {string} domain
 * @param {Uint8Array} payloadType
 * @param {Uint8Array} payload
 * @returns {Uint8Array}
 */


var formatSignaturePayload = function formatSignaturePayload(domain, payloadType, payload) {
  // When signing, a peer will prepare a Uint8Array by concatenating the following:
  // - The length of the domain separation string string in bytes
  // - The domain separation string, encoded as UTF-8
  // - The length of the payload_type field in bytes
  // - The value of the payload_type field
  // - The length of the payload field in bytes
  // - The value of the payload field
  var domainUint8Array = uint8arraysFromString(domain);
  var domainLength = varint.encode(domainUint8Array.byteLength);
  var payloadTypeLength = varint.encode(payloadType.length);
  var payloadLength = varint.encode(payload.length);
  return uint8arraysConcat([new Uint8Array(domainLength), domainUint8Array, new Uint8Array(payloadTypeLength), payloadType, new Uint8Array(payloadLength), payload]);
};
/**
 * Unmarshal a serialized Envelope protobuf message.
 *
 * @param {Uint8Array} data
 * @returns {Promise<Envelope>}
 */


Envelope.createFromProtobuf = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var envelopeData, peerId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            envelopeData = Protobuf.decode(data);
            _context.next = 3;
            return PeerId.createFromPubKey(envelopeData.publicKey);

          case 3:
            peerId = _context.sent;
            return _context.abrupt("return", new Envelope({
              peerId: peerId,
              payloadType: envelopeData.payloadType,
              payload: envelopeData.payload,
              signature: envelopeData.signature
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Seal marshals the given Record, places the marshaled bytes inside an Envelope
 * and signs it with the given peerId's private key.
 *
 * @async
 * @param {Record} record
 * @param {PeerId} peerId
 * @returns {Promise<Envelope>}
 */


Envelope.seal = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(record, peerId) {
    var domain, payloadType, payload, signData, signature;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            domain = record.domain;
            payloadType = record.codec;
            payload = record.marshal();
            signData = formatSignaturePayload(domain, payloadType, payload);
            _context2.next = 6;
            return peerId.privKey.sign(signData);

          case 6:
            signature = _context2.sent;
            return _context2.abrupt("return", new Envelope({
              peerId: peerId,
              payloadType: payloadType,
              payload: payload,
              signature: signature
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Open and certify a given marshalled envelope.
 * Data is unmarshalled and the signature validated for the given domain.
 *
 * @param {Uint8Array} data
 * @param {string} domain
 * @returns {Promise<Envelope>}
 */


Envelope.openAndCertify = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, domain) {
    var envelope, valid;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Envelope.createFromProtobuf(data);

          case 2:
            envelope = _context3.sent;
            _context3.next = 5;
            return envelope.validate(domain);

          case 5:
            valid = _context3.sent;

            if (valid) {
              _context3.next = 8;
              break;
            }

            throw errCode(new Error('envelope signature is not valid for the given domain'), codes.ERR_SIGNATURE_NOT_VALID);

          case 8:
            return _context3.abrupt("return", envelope);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

module.exports = Envelope;